export default {
  effects: {
    captions: {
      blur: 'Mờ',
      crop: 'Cắt',
      enhance: 'Tinh chỉnh',
      flip: 'Lật',
      grayscale: 'Xám',
      invert: 'Âm bản',
      mirror: 'Gương',
      rotate: 'Xoay',
      sharp: 'Làm nét',
    },
    apply: 'Áp dụng',
  },
}
